import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const FORGOT_PASSWORD = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}

  mutation sendPasswordReset($email: String!) {
    sendPasswordReset(email: $email) {
      __typename
      ... on SendPasswordResetOutput {
        result
      }

      ... on SendPasswordResetErrorOutput {
        errors {
          email
        }
      }

      ...ServerError
      ...UnauthorizedError
      ...UnauthenticatedError
    }
  }
`
